import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import FundsService from 'donor-elf-web/services/funds-service';
import ENV from 'donor-elf-web/config/environment';

export default class NewsletterNotConnectedController extends Controller {
  @service declare fundsService: FundsService;
  @service declare store: Store;

  @tracked connecting = false;
  @tracked error?: any;

  @action
  templateWillDestroy() {
    this.connecting = false;
    this.error = undefined;
  }

  @action
  async authenticateWithPrayerLetters() {
    if (this.connecting) {
      return;
    }
    this.connecting = true;
    try {
      let signInModel = this.store.createRecord('devise-sign-in');
      await signInModel.save();
      window.location.href = `${ENV.apiUrl}/oauth/prayer-letters/request-access?fund_id=${this.fundsService.selectedFund!.id}`;
    } catch (e) {
      this.error = e;
    }
  }
}
